import React from 'react';
import classnames from 'classnames';
import TextToDownload from '../textToDownload';
import AppleStoreIcon from 'images/apple-store-icon.png';
import GooglePlayIcon from 'images/google-play-icon.png';
import MadeInLA from 'images/made-in-la.svg?react-svg';
import FacebookIcon from 'images/icons/social/facebook.svg?react-svg';
import TwitterIcon from 'images/icons/social/twitter.svg?react-svg';
import InstagramIcon from 'images/icons/social/instagram.svg?react-svg';
import { MutedBackground } from 'scy/Background';
import { WideContainer } from 'scy/layouts';
import { SmallUppercase, AccentH4, AccentBody } from 'scy/text';
import { hidden } from 'scy/display.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';
import CityLinks from './CityLinks';

function SocialIcons() {
  return (
    <AccentBody className={styles.socialIcons}>
      <a
        href="https://www.facebook.com/SauceyApp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FacebookIcon />
      </a>
      <a
        href="https://twitter.com/sauceyapp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <TwitterIcon />
      </a>
      <a
        href="https://www.instagram.com/sauceyapp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <InstagramIcon />
      </a>
    </AccentBody>
  );
}

function Column({ title, className, children }) {
  return (
    <div className={classnames(styles.column, className)}>
      <AccentH4
        marginClass={classnames(margin.top_0, margin.bottom_xs)}
        className={styles.columnHeading}
      >
        {title}
      </AccentH4>
      {children}
    </div>
  );
}

function Link({ href, target, className, children }) {
  return (
    <SmallUppercase
      tag="div"
      marginClass={classnames(margin.top_0, margin.bottom_sm)}
      className={className}
    >
      <a
        href={href}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : null}
      >
        {children}
      </a>
    </SmallUppercase>
  );
}

function Footer({ responsive = true, className }) {
  return (
    <MutedBackground
      tag="footer"
      className={classnames(styles.footer, className, {
        [styles.responsive]: responsive
      })}
    >
      <WideContainer
        className={classnames(styles.container, {
          [styles.narrowContainer]: !responsive
        })}
      >
        <div className={styles.social}>
          <AccentH4 className={styles.columnHeading}>Follow Us</AccentH4>
          <SocialIcons />
        </div>

        <Column title="Company">
          <Link
            className={`${hidden} ${styles.tablet_block}`}
            href="/contact-us"
          >
            contact us
          </Link>
          <Link
            className={`${hidden} ${styles.tablet_block}`}
            href="/terms-of-service"
          >
            Terms of Service
          </Link>
          <Link
            className={`${hidden} ${styles.tablet_block}`}
            href="/privacy-policy"
          >
            Privacy Policy
          </Link>
          <Link
            className={`${hidden} ${styles.tablet_block}`}
            href="/returns-refunds"
          >
            Returns & Refunds
          </Link>
          <Link href="/careers">Careers</Link>
          <Link href="/blog" target="_blank">
            Blog
          </Link>
        </Column>

        <Column title="Contact Us" className={styles.tablet_hidden}>
          <Link href="/contact-us" target="_blank">
            Support
          </Link>
          <Link href="/terms-of-service">Terms of Service</Link>
          <Link href="/privacy-policy">Privacy Policy</Link>
          <Link href="/returns-refunds">Returns & Refunds</Link>
        </Column>

        <Column title="Partnerships">
          <Link href="/business">Corporate Accounts</Link>
          <Link href="/retailers">Retail Partners</Link>
          <Link href="https://www.dmipartners.com/saucey/" target="_blank">
            Become an Affiliate
          </Link>
        </Column>

        <Column title="Cities" className={styles.cities}>
          <CityLinks />
        </Column>

        <div className={styles.getTheApp}>
          <AccentH4 className={styles.columnHeading}>Get The App</AccentH4>
          <div className={styles.textToDownloadContainer}>
            <TextToDownload
              section="Footer"
              className={styles.textToDownload}
            />
            <div>
              <a href="https://app.adjust.com/o079l9_f06dhc">
                <img src={AppleStoreIcon} className={styles.appButton} />
              </a>
              <a href="https://app.adjust.com/f06dhc_o079l9">
                <img src={GooglePlayIcon} className={styles.appButton} />
              </a>
            </div>
          </div>
        </div>

        <div className={styles.madeInLA}>
          <MadeInLA width={120} />
        </div>
      </WideContainer>
    </MutedBackground>
  );
}

export default Footer;
